import ApiEndpoints from '@/config/ApiEndpoints';
import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';

export default class CancelSubscription {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * CancelSubscription constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle deleting the given subscription.
     *
     * @param subscriptionId
     * @param reasonId
     *
     * @returns {Promise}
     */
    handle(subscriptionId, reasonId) {
        let apiUrl = prepareUrl(ApiEndpoints['subscriptions.delete'], [subscriptionId, reasonId]);

        return this.apiService.delete(apiUrl);
    }
}
